// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"228":"74c741336ec10db5","5246":"441d05542d66e838","6427":"a531cfab792c421e","7098":"c62eb939fc024eaf","7473":"ec5c5d4a637d4172"}[chunkId] + ".js";
};